import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, BookOpen } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white dark:bg-black transition-colors duration-300">
      <div className="container mx-auto px-6 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 dark:text-white mb-4 font-inter">
            About Me
          </h2>
          <div className="w-20 h-1 bg-blue-600 dark:bg-blue-400 mx-auto rounded-full" />
        </motion.div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-8"
          >
            <div className="prose prose-lg dark:prose-invert font-inter text-gray-600 dark:text-gray-300">
              <p>
                I'm a cybersecurity enthusiast and software development engineer dedicated to building secure, 
                scalable, and efficient digital solutions. My expertise bridges the gap between offensive security 
                and robust backend architecture.
              </p>
              <p>
                From analyzing MANET security protocols to engineering multi-tenant healthcare SaaS backends, 
                I focus on creating systems that are resilient by design. I'm currently pursuing my B.Tech in IT, 
                blending academic rigor with hands-on technical implementation.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="apple-card p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="p-3 rounded-2xl bg-gray-50 dark:bg-gray-800 text-blue-600 dark:text-blue-400">
                  <GraduationCap size={24} />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white font-inter">Education</h3>
              </div>

              <div className="space-y-6">
                <div>
                  <h4 className="text-lg font-bold text-gray-900 dark:text-white font-inter leading-tight">
                    B.Tech in Information Technology
                  </h4>
                  <p className="text-gray-500 dark:text-gray-400 text-sm mt-1">
                    Charotar University of Science and Technology
                  </p>
                  <div className="flex justify-between items-center mt-3">
                    <span className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">
                      2022 — 2026
                    </span>
                    <span className="px-3 py-1 rounded-full bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 text-xs font-bold">
                      GPA: 7.92 / 10
                    </span>
                  </div>
                </div>

                <div className="pt-6 border-t border-gray-100 dark:border-gray-800">
                  <div className="flex items-center gap-2 text-gray-500 dark:text-gray-400 text-sm">
                    <BookOpen size={16} />
                    <span>Focus: Network Security, Penetration Testing, Full-stack Architecture</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
